import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading, configured } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-white/60 font-inter text-sm tracking-wide">Loading…</p>
      </div>
    );
  }

  if (!configured) {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }

  if (!user) {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
